import React from 'react'
import { connect } from 'react-redux'
import { UserOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Avatar, Badge } from 'antd'
import { FormattedMessage } from 'react-intl'
import { history } from '../../../../App'
import styles from './style.module.scss'
import { Link } from 'react-router-dom'
@connect(({ user }) => ({ user }))
class ProfileMenu extends React.Component {
  state = {
    count: 7,
  }

  logout = () => {
    const { dispatch } = this.props
    localStorage.removeItem(window.SITE_CONFIG.STORAGE.USER)
    localStorage.removeItem(window.SITE_CONFIG.STORAGE.TOKEN)
    dispatch({
      type: 'user/LOGOUT',
    })
    history.push('/user/login')
  }



  addCount = () => {
    let { count } = this.state
    count += 1
    this.setState({
      count,
    })
  }

  render() {

    const { user } = this.props
    const { count } = this.state
    const image = ""


    const menu = (
      <Menu selectable={false}>
        <Menu.Item> 
          <strong>
            <FormattedMessage id="topBar.profileMenu.hello" />, {(user.user && user.user.firstName) ? user.user.firstName + " " + user.user.lastName : "User"}
          </strong>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          {/* <div>
            <strong>
              <FormattedMessage id="topBar.profileMenu.role" />:{' '}
            </strong>
            {user.user && user.user.accountType}
          </div> */}
          <div>
            <strong>
              <FormattedMessage id="topBar.profileMenu.email" />:{' '}
            </strong>
            {user.user && user.user.email}
            <br />
            {/* <strong>
              <FormattedMessage id="topBar.profileMenu.phone" />:{' '}
            </strong>
            {user.mobileNo || '-'} */}
          </div>
        </Menu.Item>
        <Menu.Divider />
        {/* <Menu.Item>
          <Link to="/dashboard/profile" >
            <i className={`${styles.menuIcon} icmn-user`} />
            <FormattedMessage id="topBar.profileMenu.editProfile" />
          </Link>
        </Menu.Item>
        <Menu.Divider /> */}
        <Menu.Item>
          <a href="javascript: void(0);" onClick={this.logout}>
            <i className={`${styles.menuIcon} icmn-exit`} />
            <FormattedMessage id="topBar.profileMenu.logout" />
          </a>
        </Menu.Item>
      </Menu>
    )
    return (
      <Dropdown overlay={menu} trigger={['click']} onVisibleChange={this.addCount}>
        <div className={styles.dropdown}>
          {image ? <Avatar src={image} className={styles.avatar} shape="square" size="large" icon={<UserOutlined />} /> : <Avatar className={styles.avatar} shape="square" size="large" icon={<UserOutlined />} />}
        </div>
      </Dropdown>
    );
  }
}

export default ProfileMenu
